import { put, call } from "redux-saga/effects";
import { VisaCareCaseAPI } from "../../utils/api/VisaCareCaseAPI";
import { SAVE_EMPTY_CASE_SUCCESS,SAVE_EMPTY_CASE_FAILED ,
    UPDATE_EMPTY_CASE_SUCCESS,UPDATE_EMPTY_CASE_FAILED,
    SAVE_CASEFLOW_SUCCESS,SAVE_CASEFLOW_FAILED ,
    UPDATE_CASEFLOW_SUCCESS,UPDATE_CASEFLOW_FAILED,
    SAVE_WORKFLOW_SUCCESS,SAVE_WORKFLOW_FAILED ,
    UPDATE_WORKFLOW_SUCCESS,UPDATE_WORKFLOW_FAILED,
    SAVE_EMP_BIOGRAPHICS_SUCCESS,SAVE_EMP_BIOGRAPHICS_FAILED ,
    UPDATE_EMP_BIOGRAPHICS_SUCCESS,UPDATE_EMP_BIOGRAPHICS_FAILED  ,
    SAVE_H1BFORMS_SUCCESS,SAVE_H1BFORMS_FAILED ,
    UPDATE_H1BFORMS_SUCCESS,UPDATE_H1BFORMS_FAILED,
   GET_ALLCASEFLOW_SUCCESS, GET_ALLCASEFLOW_FAILED,
    
    GET_CASEFLOW_INITIATION_SUCCESS,GET_CASEFLOW_INITIATION_FAILED,
    GET_EMPLOYEE_BIOG_SUCCESS,GET_EMPLOYEE_BIOG_FAILED,GET_H1BFORMS_SUCCESS,GET_H1BFORMS_FAILED,
    SAVEPDF_H1BFORMS_SUCCESS, SAVEPDF_H1BFORMS_FAILED,UPLOADFILE_CASEFLOW_SUCCESS,UPLOADFILE_CASEFLOW_FAILED,
    UPLOADFILE_H1BFORMS_SUCCESS,UPLOADFILE_H1BFORMS_FAILED,GET_CASEID_SUCCESS,GET_CASEID_FAILED,
  
    GET_CASEDETAILS_SUCCESS,GET_CASEDETAILS_FAILED ,
    GET_ATTORNEYG28DETAILS_SUCCESS,GET_ATTORNEYG28DETAILS_FAILED ,
    SAVE_ATTORNEYG28DETAILS_SUCCESS,SAVE_ATTORNEYG28DETAILS_FAILED ,
    CREATE_H1BG28FORMS_SUCCESS,CREATE_H1BG28FORMS_FAILED,

    UPDATE_I907FORM_SUCCESS,UPDATE_I907FORM_FAILED,
    CREATE_I907FORMS_SUCCESS,CREATE_I907FORMS_FAILED,
    SAVE_I907FORM_SUCCESS,SAVE_I907FORM_FAILED,
    GET_I907FORM_SUCCESS,GET_I907FORM_FAILED,
    GET_EMPLOYER_LIST_SUCCESS,GET_EMPLOYER_LIST_FAILED,
    GET_PETITION_APPROVED_SUCCESS,GET_PETITION_APPROVED_FAILED,
    CREATE_EMPLOYEMENT_SUCCESS,CREATE_EMPLOYEMENT_FAILED,
    UPDATE_EMPLOYEMENT_SUCCESS,UPDATE_EMPLOYEMENT_FAILED, UPDATE_ALLEMPLOYEMENT_SUCCESS,UPDATE_ALLEMPLOYEMENT_FAILED,
    GET_PLAN_ALLCASEFLOW_SUCCESS,GET_PLAN_ALLCASEFLOW_FAILED
} from "../actions/VisaCareCase";

export function* caseflowCreateEmptyCase(request: any) {
 
      try {
             const result=yield call(VisaCareCaseAPI.caseflowCreateEmptyCase, request.input);
           yield put({ 
              type: SAVE_EMPTY_CASE_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: SAVE_EMPTY_CASE_FAILED, payload: e.message });
      }
  }

  export function* caseflowUpdateCase(request: any) {
  
      try {
             const result=yield call(VisaCareCaseAPI.caseflowUpdateCase, request.input);
           yield put({ 
              type: UPDATE_EMPTY_CASE_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: UPDATE_EMPTY_CASE_FAILED, payload: e.message });
      }
  }

  export function* caseflowInitiationCreate(request: any) {
 
      try {
             const result=yield call(VisaCareCaseAPI.caseflowInitiationCreate, request.input);
           yield put({ 
              type: SAVE_CASEFLOW_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: SAVE_CASEFLOW_FAILED, payload: e.message });
      }
  }

  export function* caseflowInitiationUpdate(request: any) {
 
      try {
             const result=yield call(VisaCareCaseAPI.caseflowInitiationUpdate, request.input);
           yield put({ 
              type: UPDATE_CASEFLOW_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: UPDATE_CASEFLOW_FAILED, payload: e.message });
      }
  }
  export function* workflowCreate(request: any) {
  
      try {
             const result=yield call(VisaCareCaseAPI.workflowCreate, request.input);
           yield put({ 
              type: SAVE_WORKFLOW_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: SAVE_WORKFLOW_FAILED, payload: e.message });
      }
  }

  export function* workflowUpdateWorkflows(request: any) {
 
      try {
             const result=yield call(VisaCareCaseAPI.workflowUpdateWorkflows, request.input);
           yield put({ 
              type: UPDATE_WORKFLOW_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: UPDATE_WORKFLOW_FAILED, payload: e.message });
      }
  }
  export function* employeeBiographicsCreate(request: any) {
 
      try {
             const result=yield call(VisaCareCaseAPI.employeeBiographicsCreate, request.input);
           yield put({ 
              type: SAVE_EMP_BIOGRAPHICS_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: SAVE_EMP_BIOGRAPHICS_FAILED, payload: e.message });
      }
  }

  export function* employeeBiographicsUpdate(request: any) {
 
      try {
             const result=yield call(VisaCareCaseAPI.employeeBiographicsUpdate, request.input);
           yield put({ 
              type: UPDATE_EMP_BIOGRAPHICS_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: UPDATE_EMP_BIOGRAPHICS_FAILED, payload: e.message });
      }
  }

  export function* h1bformsCreate(request: any) {
  
      try {
             const result=yield call(VisaCareCaseAPI.h1bformsCreate, request.input);
           yield put({ 
              type: SAVE_H1BFORMS_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: SAVE_H1BFORMS_FAILED, payload: e.message });
      }
  }

  export function* h1bformsUpdate(request: any) {
  
      try {
             const result=yield call(VisaCareCaseAPI.h1bformsUpdate, request.input);
           yield put({ 
              type: UPDATE_H1BFORMS_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: UPDATE_H1BFORMS_FAILED, payload: e.message });
      }
  }

  export function*getAllCaseflows (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.getAllCaseflows,request);
   
      
      yield put({
          type: GET_ALLCASEFLOW_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_ALLCASEFLOW_FAILED, payload: e.message });
    }
}

export function*getAllCaseflow (request:any) {
  try {
    
      const { data } = yield call(VisaCareCaseAPI.getAllCaseflow,request);
 
 
    yield put({
        type: GET_CASEID_SUCCESS,
        payload: data 
      });
  } catch (e) {
      yield put({ type: GET_CASEID_FAILED, payload: e.message });
  }
}

export function*getCaseflowInitiationDetails (request:any) {
  try {
    
      const { data } = yield call(VisaCareCaseAPI.getCaseflowInitiationDetails,request);
  
    yield put({
        type: GET_CASEFLOW_INITIATION_SUCCESS,
        payload: data 
      });
  } catch (e) {
      yield put({ type: GET_CASEFLOW_INITIATION_FAILED, payload: e.message });
  }
}
export function*getEmployeeBiographicsDetails (request:any) {
  try {
    
      const { data } = yield call(VisaCareCaseAPI.getEmployeeBiographicsDetails,request);
  
    yield put({
        type: GET_EMPLOYEE_BIOG_SUCCESS,
        payload: data 
      });
  } catch (e) {
      yield put({ type: GET_EMPLOYEE_BIOG_FAILED, payload: e.message });
  }
}
export function*getH1bformsDetails (request:any) {
  try {
    
      const { data } = yield call(VisaCareCaseAPI.getH1bformsDetails,request);
  
    yield put({
        type: GET_H1BFORMS_SUCCESS,
        payload: data 
      });
  } catch (e) {
      yield put({ type: GET_H1BFORMS_FAILED, payload: e.message });
  }
}
export function* h1bformsPdfSubmit(request: any) {
 
    try {
           const { data }=yield call(VisaCareCaseAPI.h1bformsPdfSubmit, request);
           
         yield put({ 
            type: SAVEPDF_H1BFORMS_SUCCESS,     
            payload: data
            
        });
    } catch (e) {
        yield put({ type: SAVEPDF_H1BFORMS_FAILED, payload: e.message });
    }
}

export function* uploadFileCaseFlow(request: any) {
 
    try {
           const result=yield call(VisaCareCaseAPI.uploadFileCaseFlow, request.input);
         yield put({ 
            type: UPLOADFILE_CASEFLOW_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPLOADFILE_CASEFLOW_FAILED, payload: e.message });
    }
}
export function* uploadFileH1BPetitioner(request: any) {
 
    try {
           const result=yield call(VisaCareCaseAPI.uploadFileH1BPetitioner, request.input);
         yield put({ 
            type: UPLOADFILE_H1BFORMS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPLOADFILE_H1BFORMS_FAILED, payload: e.message });
    }
}

export function*getCaseDetails (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.getCaseDetails,request);
   
      
      yield put({
          type: GET_CASEDETAILS_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_CASEDETAILS_FAILED, payload: e.message });
    }
}

export function*getAttorneyG28Details (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.getAttorneyG28Details,request);
    
      yield put({
          type: GET_ATTORNEYG28DETAILS_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_ATTORNEYG28DETAILS_FAILED, payload: e.message });
    }
}

export function* h1bg28formsCreate(request: any) {
  
    try {
        
           const result=yield call(VisaCareCaseAPI.h1bg28formsCreate, request.input);
         yield put({ 
            type: SAVE_ATTORNEYG28DETAILS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_ATTORNEYG28DETAILS_FAILED, payload: e.message });
    }
}

export function*generateG28Pdf (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.generateG28Pdf,request);
    
      yield put({
          type: CREATE_H1BG28FORMS_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: CREATE_H1BG28FORMS_FAILED, payload: e.message });
    }
}



export function*getI907FormDetails (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.getI907FormDetails,request);
    
      yield put({
          type: GET_I907FORM_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_I907FORM_FAILED, payload: e.message });
    }
}

export function* createI907Form(request: any) {
  
    try {
        
           const result=yield call(VisaCareCaseAPI.createI907Form, request.input);
         yield put({ 
            type: SAVE_I907FORM_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I907FORM_FAILED, payload: e.message });
    }
}
export function* updateI907Form(request: any) {
  
    try {
        
           const result=yield call(VisaCareCaseAPI.updateI907Form, request.input);
         yield put({ 
            type: UPDATE_I907FORM_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I907FORM_FAILED, payload: e.message });
    }
}
export function*generateI907Pdf (request:any) { 
    try {
      
        const { data } = yield call(VisaCareCaseAPI.generateI907Pdf,request);
         
      yield put({
          type: CREATE_I907FORMS_SUCCESS,
          payload: data 
        });
    } catch (e) {    
        yield put({ type: CREATE_I907FORMS_FAILED, payload: e.message });        
    }
}

export function*getAllCompanyProfileDetails () {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.getAllCompanyProfileDetails);
   
 
      yield put({
          type: GET_EMPLOYER_LIST_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_EMPLOYER_LIST_FAILED, payload: e.message });
    }
}
export function*getCaseDetailsByPetitionApproved (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.getCaseDetailsByPetitionApproved,request);
    
      yield put({
          type: GET_PETITION_APPROVED_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_PETITION_APPROVED_FAILED, payload: e.message });
    }
  }

  export function*createEmployeement (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.createEmployeement,request);
    
      yield put({
          type: CREATE_EMPLOYEMENT_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: CREATE_EMPLOYEMENT_FAILED, payload: e.message });
    }
  }

  export function*updateEmployeement (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.updateEmployeement,request);
    
      yield put({
          type: UPDATE_EMPLOYEMENT_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: UPDATE_EMPLOYEMENT_FAILED, payload: e.message });
    }
  }

  export function*updateAllEmployeement (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.updateAllEmployeement,request);
    
      yield put({
          type: UPDATE_ALLEMPLOYEMENT_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: UPDATE_ALLEMPLOYEMENT_FAILED, payload: e.message });
    }
  }

  export function*getCaseflowsByPlanCompanyautoIdAndfilingUserName (request:any) {
    try {
      
        const { data } = yield call(VisaCareCaseAPI.getCaseflowsByPlanCompanyautoIdAndfilingUserName,request);
   
      
      yield put({
          type: GET_PLAN_ALLCASEFLOW_SUCCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_PLAN_ALLCASEFLOW_FAILED, payload: e.message });
    }
}
